"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TemplateIcon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function TemplateIcon(props) {
  return _react2.default.createElement(_Icon2.default, props, _react2.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4V9H19L14 4Z"
  }), _react2.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.5V4H7C5.89543 4 5 4.89543 5 6V18C5 19.1046 5.89543 20 7 20H17C18.1046 20 19 19.1046 19 18V11H14.5C13 11 12 10 12 8.5ZM10.2338 12C11.0111 12 11.4912 11.152 11.0913 10.4855L9.93724 8.56207C9.53126 7.88543 8.53821 7.92357 8.18532 8.62936L7.22361 10.5528C6.89116 11.2177 7.37465 12 8.11803 12H10.2338ZM11 16C11 17.1046 10.1046 18 9 18C7.89543 18 7 17.1046 7 16C7 14.8954 7.89543 14 9 14C10.1046 14 11 14.8954 11 16ZM14 14C13.4477 14 13 14.4477 13 15V17C13 17.5523 13.4477 18 14 18H16C16.5523 18 17 17.5523 17 17V15C17 14.4477 16.5523 14 16 14H14Z"
  }));
}